import type { GateReason } from '../contract';
import { InfoIcon } from 'lucide-react';
import { Button } from '../primitives/Button';

/**
 * Shown above everything when a scan is gated. A finding, not a failure: we
 * paused the deeper AI checks because there is nothing on the site yet for an
 * AI to find and repeat. Plain reason, the evidence, one button.
 */
export function GateBanner({
  reasons,
  onSeeFixes,
}: {
  reasons: GateReason[];
  onSeeFixes: () => void;
}) {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-5">
      <div className="flex items-start gap-3">
        <InfoIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600" />
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-semibold text-gray-900">
            We paused the deeper checks — there is nothing here for AI to find yet
          </h2>
          <p className="mt-1 text-sm text-gray-700">
            This is a finding, not a failure. Until your website says something an AI can read and
            repeat, asking the AI engines about you only turns up other names. Here is exactly what is
            in the way:
          </p>
          <ul className="mt-3 space-y-3">
            {reasons.map((r) => (
              <li key={r.code}>
                <p className="text-sm font-semibold text-gray-900">{r.plain}</p>
                <ul className="mt-1 space-y-0.5">
                  {r.evidence.map((e, i) => (
                    <li key={i} className="text-xs text-gray-500">
                      · {e}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
          <Button className="mt-4" onClick={onSeeFixes}>
            See what to fix first
          </Button>
        </div>
      </div>
    </div>
  );
}
